import { createStore } from "vuex";
import { apiUserRole } from "@/api/requestApis.js";
import { roleRouters } from "@/router/index.js";
const store = createStore({
    state() {
        return {
            userMenu: [],
            activeMenu: {},
        };
    },
    mutations: {
        setUserMenu(state, payload) {
            state.userMenu = payload;
        },
        setActiveMenu(state, payload) {
            state.activeMenu = payload;
        },
    },
    actions: {
        asyncSetActiveMenu({ commit }, payload) {
            commit("setActiveMenu", payload);
        },
        async clearUserMenu({ commit }) {
            commit("setUserMenu", []);
        },
        async asyncSetUserMenu({ commit }, params) {
            const userRole = await apiUserRole(params);
            const routerList = roleRouters.filter((val) => {
                return (userRole || []).includes(val.meta.auth);
            });
            commit("setUserMenu", routerList);
            return Promise.resolve(routerList);
        },
    },
});

export default store;
